
import { environment } from 'src/environments/environment';

export class ConsultantsMissions {
  private id: number;
  private title: any;
  private description: any;
  private certificat_path: any;

  constructor(ConsultantsMissions: any) {
    this.id = ConsultantsMissions.id;
    this.title = ConsultantsMissions.title;
    this.description = ConsultantsMissions.description;
    this.certificat_path = ConsultantsMissions.certificat_path;
  }

  getId(): number {
    return this.id;
  }

  getTitle(): string {
    return this.title;
  }

  getDescription(): string {
    return this.description;
  }

  getCertificatPath(): string {
    return (this.certificat_path != null && this.certificat_path != '') ? environment.apiUrl + this.certificat_path : this.certificat_path;
  }
}